import { Component, OnInit, ViewChild } from '@angular/core';

import { ChartDataSets, ChartOptions, ChartType, ChartPoint } from 'chart.js';
import { Color, BaseChartDirective, Label, MultiDataSet } from 'ng2-charts';
import * as pluginAnnotations from 'chartjs-plugin-annotation';

import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';

import { HomeService } from '../../../shared/_services/home.service';
import { HomeData } from '../../../shared/models/homeData.model';

const now = new Date();

@Component({
  selector: 'app-home-assistant',
  templateUrl: './home-assistant.component.html',
  styleUrls: ['./home-assistant.component.css']
})
export class HomeAssistantComponent implements OnInit {

  assistantStats: HomeData = new HomeData();
  activePortfolio: number;
  activeWeekPortfolio: number;
  activeDayPortfolio: number;
  blockedPortfolio: number;
  activeMonthPortfolio: number;
  managements: number[];
  days: string[];

  model: NgbDateStruct;

  public lineChartData: ChartDataSets[] = [
    //{ data: [], label: 'No. Gestiones', yAxisID: 'y-axis-1' }
    { data: [2, 5, 9, 7, 1], label: 'No. Gestiones', yAxisID: 'y-axis-1' }
  ];

  //public lineChartLabels: Label[] = [];
  public lineChartLabels: Label[] = ['19/04/12', '19/04/13', '19/04/14', '19/04/15', '19/04/16'];

  public lineChartOptions: (ChartOptions) = {
    responsive: true,
    scales: {
      // We use this empty structure as a placeholder for dynamic theming.
      xAxes: [{}],
      yAxes: [
        {
          id: 'y-axis-1',
          position: 'left',
          gridLines: {
            color: 'rgba(0,0,255,0.3)',
          },
          ticks: {
            fontColor: 'rgba(0, 0, 255, 0.3)',
            min: 0,
            max: 10,
            stepSize: 2
          }
        }
      ]
    }
  };
  public lineChartColors: Color[] = [
    { 
      backgroundColor: 'rgba(0, 0, 255, 0.3)',
      borderColor: 'rgba(0, 0, 255, 0.3)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];

  public lineChartLegend = true;
  public lineChartType = 'line';
  public lineChartPlugins = [pluginAnnotations];

  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  public doughnutChartLabels: Label[] = ['Cartera cerrada', 'Cartera Abierta'];
  public doughnutChartData = [];
  public doughnutChartType: ChartType = 'doughnut';

  public doughnutColors: any[] = [
    { backgroundColor: ["#ffe199", "#86c7f3"] },
    { borderColor: ["#AEEBF2", "#FEFFC9"] }];

  constructor(private homeService: HomeService, private calendar: NgbCalendar) { }

  ngOnInit() {
    this.selectToday();

    this.homeService.getAssistantStats()
      .subscribe(stats => {
        console.log(stats);
        this.assistantStats = stats;

        this.activePortfolio = this.assistantStats.portfolioCount[0];
        this.activeWeekPortfolio = Math.round(this.activePortfolio / 4);
        this.activeDayPortfolio = Math.round(this.activeWeekPortfolio / 5);

        this.blockedPortfolio = this.assistantStats.portfolioCount[1];

        this.activeMonthPortfolio = this.assistantStats.portfolioCount[2];

        //this.lineChartData['data'] = this.assistantStats.managementCount;
        //this.lineChartLabels = this.assistantStats.dates;

        let chartData = [this.assistantStats.portfolioCount[1], this.assistantStats.portfolioCount[2]];
        this.doughnutChartData = chartData;
      });

  }

  selectToday() {
    this.model = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
  }

}

